import { render, staticRenderFns } from "./TechExpertUser.vue?vue&type=template&id=5a2e06c8&scoped=true"
import script from "./TechExpertUser.vue?vue&type=script&lang=js"
export * from "./TechExpertUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e06c8",
  null
  
)

export default component.exports